// React-Screen CProductSelectMode ("Produktauswahlmodus") - Strangler
// Phase 5, Klasse B. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle productselectmode.js (aus
// lib/scripts/pos/components/CMP_CProductSelectMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CProductSelectMode.html, gezogen
// aus tests/visual-baseline/31-overlay-produkt-umbuchen.html.
//
// WEG DAHIN, ueberraschend: die einzige Konstruktionsstelle liegt in
// CChangesPanel.productChange - und dort ist die Knopf-Verdrahtung
// auskommentiert. Erreichbar ist der Screen ueber das INVENTUR-Panel, das
// seinen Knopf "Produkt umbuchen" per `this.Main.cmpChanges.productChange`
// an genau diese Methode haengt. (Der Screen galt hier zwischenzeitlich als
// toter Code - er ist es nicht.)
//
// Wie CPosDisabledMode/CMainPOSInfoMode ist er ein displayTarget: waehrend
// er offen ist, laufen Produkt-Eingaben nicht auf den Bon, sondern ueber
// CBonManager.addProduct in showPrice() bzw. - weil newProdId hier DEFINIERT
// ist - in den Zweig, der newProdId setzt und den OK-Knopf einblendet.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
// classValue eingefroren, weil showPrice die Texte per reDraw() wechselt -
// dabei folgt die Klasse dem Wert, aber die Elemente wandern ans Ende.
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function ProductSelectModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: okButton.properties.events.onMousedown = this.ok. Er ist anfangs
  // unsichtbar; eingeblendet wird er von domain/bon/bonentryops.js, sobald
  // ein Zielprodukt gewaehlt wurde (s. components-Adapter in prepare()).
  const okButton = (
    <div {...bridge.widget('7', 'CPushButton', {
      events: { onMousedown: () => bridge.ok(), onMouseout: true, onMouseup: true },
      attributes: { onMousedown_parameter_0: bridge.id },
      proto: CPushButton.prototype,
    })} className="CPushButton okbutton" style={{ visibility: bridge.state.okVis }}>
      <Caption bridge={bridge} path="7:0" addclass="" value=" " />
    </div>
  );
  const backButton = (
    <div {...bridge.widget('8', 'CPushButton', {
      events: { onMousedown: () => bridge.finish(), onMouseout: true, onMouseup: true },
      attributes: { onMousedown_parameter_0: bridge.id },
      proto: CPushButton.prototype,
    })} className="CPushButton backbutton">
      <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
    </div>
  );
  const contentText = (
    <Caption bridge={bridge} path="4" addclass="contenttext" value={bridge.state.content} />
  );
  const priceText = <Caption bridge={bridge} path="5" addclass="pricetext" value={bridge.state.price} />;
  const unitsText = <Caption bridge={bridge} path="6" addclass="unitstext" value={bridge.state.units} />;

  // REIHENFOLGE: nach der Produktwahl haengt Legacy erst den okButton
  // (bonentryops.js) und dann contentText/priceText/unitsText (showPrice)
  // per reDraw() ans ENDE des Elternknotens. Das bildet die JSX ab - die IDs
  // kommen aus dem Pfad, nur die Position aendert sich.
  const gewaehlt = bridge.state.preisDa;

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'PRODUCT_SELECT_MODE')} />
      {!gewaehlt && contentText}
      {!gewaehlt && priceText}
      {!gewaehlt && unitsText}
      {!gewaehlt && okButton}
      {backButton}
      {gewaehlt && okButton}
      {gewaehlt && contentText}
      {gewaehlt && priceText}
      {gewaehlt && unitsText}
    </>
  );
}

export const CProductSelectMode = defineReactScreen({
  className: 'CProductSelectMode',
  addclass: 'CProductSelectMode CashWindow',
  htmlType: 'div',
  Screen: ProductSelectModeScreen,
  initialState: { content: '', price: ' ', units: ' ', preisDa: false, okVis: 'hidden' },
  // Felder des Legacy-Konstruktors. Sie gehoeren in den KONSTRUKTOR:
  // CChangesPanel.productChange setzt prodId und prodQty direkt nach
  // addChild() und ruft erst danach draw().
  // newProdId ist bewusst der String "not defined" - domain/bon/bonentryops
  // prueft `typeof displayTarget.newProdId != "undefined"` und geht deshalb
  // bei DIESEM Screen in den Zweig, der newProdId setzt und den OK-Knopf
  // einblendet (bei CPosDisabledMode ist das Feld undefiniert und der Zweig
  // wird uebersprungen).
  fields: () => ({
    ProdId: null,
    ProdQty: null,
    newProdId: 'not defined',
  }),
  prepare(bridge) {
    bridge.state.content = bridge.t('LABELS', 'PRODUCT_SELECT_MODE_TEXT');

    bridge.Main = POS.sessions.getSessionComponent();

    bridge.Main.BonManager.displayMode = 'info';
    bridge.Main.BonManager.displayTarget = bridge;

    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);
    for (var i = 0; i < bridge.Main.components.bonedit.children.length; i++) {
      if (i != 6)
        bridge.Main.components.bonedit.children[i].setEnabled(false);
    }

    bridge.Main.confirmInput();

    // ADAPTER fuer domain/bon/bonentryops.js: dort steht woertlich
    //   displayTarget.newProdId = productId;
    //   displayTarget.components.okButton.properties.styles.visibility = "visible";
    //   displayTarget.components.okButton.reDraw();
    // Ein React-Screen hat kein components-Verzeichnis - ohne diesen Adapter
    // wirft der Zweig "Cannot read properties of undefined (reading
    // 'properties')" und die Umbuchung bricht ab (live so passiert). Der
    // Adapter nimmt die Legacy-Schreibweise entgegen und leitet sie in den
    // Zustand um.
    bridge.components = {
      okButton: {
        properties: { styles: {} },
        reDraw: () => bridge.update({
          okVis: bridge.components.okButton.properties.styles.visibility || 'hidden',
        }),
      },
    };
  },
  methods: {
    // Aufrufer: CBonManager.addProduct ueber displayTarget.
    showPrice(bridge, parameters) {
      const prodText = parameters[0];
      const prodPrice = parameters[1];
      const prodUnit = parameters[2];

      // Der Legacy-Zweig mit wholeText war auskommentiert - bleibt es.
      bridge.update({
        content: prodText,
        price: prodPrice + ' &euro;',
        units: 'pro ' + prodUnit,
        preisDa: true,
      });
    },
    // OK: Umbuchung ausfuehren, wenn beide Produkte dieselbe ChangeGroup
    // haben.
    ok(bridge) {
      if (bridge.prodId == bridge.newProdId) {
        var text = bridge.t('MESSAGES', 'SAME_PRODUCT');
        POS.message.show(text, 'warning', '');
        return;
      }

      // SQL-Texte ZEICHENGENAU wie im Legacy (Master/Slave-Routing).
      var sql = 'SELECT ChangeGroup FROM PROD WHERE PROD_ID = ' + bridge.prodId;

      var r1 = POS.SQLiteCon.execute(sql);
      $.when(r1).then(function (rows) {
        sql = 'SELECT ChangeGroup FROM PROD WHERE PROD_ID = ' + bridge.newProdId;
        var changeGroup1 = rows[0].ChangeGroup;
        var r2 = POS.SQLiteCon.execute(sql);
        $.when(r2).then(function (rows2) {
          var changeGroup2 = rows2[0].ChangeGroup;

          if (!changeGroup1 || !changeGroup2 || (changeGroup1 != changeGroup2)) {
            var text = bridge.t('MESSAGES', 'PRODUCTS_NOT_CHANGEABLE');
            POS.message.show(text, 'warning', '');
          } else {
            bridge.Main.BonManager.productChange(bridge.prodId, bridge.prodQty, bridge.newProdId);
          }

          bridge.restoreMainPos();
          bridge.removeMe();
        });
      });
    },
    restoreMainPos(bridge) {
      bridge.Main.BonManager.displayMode = 'normal';
      bridge.Main.BonManager.displayTarget = null;

      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonfnc.setEnabled(true);
      bridge.Main.components.leftPad.setEnabled(true);

      bridge.Main.components.bonedit.setEnabled(true);
      for (var i = 0; i < bridge.Main.components.bonedit.children.length; i++) {
        bridge.Main.components.bonedit.children[i].setEnabled(true);
      }

    },
    finish(bridge) {
      bridge.restoreMainPos();
      bridge.removeMe();
    },
  },
});
